<template>
    <div id="app">
        <router-view :key="$route.path" />
    </div>
</template>

<script>
    import Vue, { defineComponent } from 'vue'
    import { logger } from '@/utils/logger'
    import { i18n } from './utils/i18n'
    import { setLocalMetadata } from '@/services/marketing'
    import { runWithRetryLogic } from '@/utils/http-client'

    export default defineComponent({
        name: 'App',
        metaInfo: {
            titleTemplate: (titleChunk) => {
                // If undefined or blank then we don't need the hyphen
                return titleChunk ? `${titleChunk} | Aven Auto Card` : 'Aven Auto Card: A Credit Card backed by Auto Equity'
            },
            meta: [
                {
                    name: 'description',
                    vmid: 'description',
                    content: 'Refinance your existing auto loan for insanely low rates. Save every single month, for the entirety of the loan.',
                },
            ],
        },
        created() {
            // Set Default Cookie Settings
            Vue.$cookies.config('30d', '', `${process.env.VUE_APP_COOKIES_URL}`, true, 'Strict')

            // Set Locale for Language
            let locale = 'en'
            if (this.$cookies.isKey('locale')) {
                locale = this.$cookies.get('locale')
            } else {
                if (navigator.userLanguage) {
                    locale = navigator.userLanguage.includes('es') ? 'es' : 'en'
                } else if (navigator.language) {
                    locale = navigator.language.includes('es') ? 'es' : 'en'
                } else {
                    logger.info('Unable to determine user langauge from javascript, defaulting to "en"')
                }
            }
            i18n.locale = locale
            this.$cookies.set('locale', locale)
        },
        mounted() {
            runWithRetryLogic(setLocalMetadata, 2)
        },
    })
</script>

<style lang="scss">
    @import 'node_modules/aven_shared/src/styles/main';
</style>
